import PaymentStatus from './payment-status.vue';
export default PaymentStatus;
